module.exports = __webpack_public_path__ + "static/img/US.6c9d2d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/US.svg
// module id = tCT3
// module chunks = 66